module.exports = function() {
  return new Worker(__webpack_public_path__ + "fef876a5ff8890744e99.worker.js");
};